import { Course } from '@edassist/api';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CreditHoursService {
	static getTotalCreditHours(courses: Array<Course>): number {
		return courses
			.map((course) => course.creditHours)
			.reduce((a: number, b: number) => a + b, 0);
	}
}
